module.exports = __webpack_public_path__ + "static/media/stop-blue.bbe6bf13.png";